import React, { useEffect, useState, useMemo } from "react";
import { useData } from "../../../context/DataContext";
import {
    Box, Card, CardContent, Grid,
    FormControlLabel,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography, Divider,
} from "@mui/material";
import SingleSelect from "../../../components/Selections/singleSelect";
import * as XLSX from 'xlsx';
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";
import CustomButton from '../../../components/buttons/customButton';
import DownloadIcon from '@mui/icons-material/Download';
import { getClientTheme } from "../../../theme/clientTheme";

function AdOptionOveralReport() {
    const { levels = [], villageGroups = [], years = [], farmers = [], user = {}, handleVillageGroupAdoptionSummary, user_client_id, villageGroupAdoptionSummaryReport } = useData();
    // const levelOptions = [{ value: 1, label: "Groups" }, ...user_client_id === 2 ? [] : [{ value: 2, label: "Villages" }]]

    const clientTheme = getClientTheme(user_client_id);
    const [state, setState] = useState({
        selectedRadioOption: "",
        villagesArray: [],
        groupsArray: [],
        selected_villages: [],
        selected_groups: []
    });

    const [yearId, setYearId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setYearId(years[0]?.value);
        handleVillageGroupAdoptionSummary(years[0]?.value);
        setState(prev =>({
            ...prev,
            selectedRadioOption:user_client_id === 1 ? 1 :2 
        }));

        if (villageGroups && villageGroups.length > 0) {
            let villageData = [];
            let groupData = [];
            const villageGroupData = villageGroups[3]?.data;

            if (user.level_id === 1) {
                villageData = villageGroupData.filter((item) => item.village_id !== "").map(village => ({
                    value: +village.village_id,
                    label: village.village
                }));
            } else if (user.level_id === 2) {
                groupData = villageGroupData.map(group => ({
                    value: +group.group_id,
                    label: group.Groups
                }));
            } else {
                villageData = villageGroupData.filter((item) => item.village_id !== "").map(village => ({
                    value: +village.village_id,
                    label: village.village
                }));

                groupData = villageGroupData.filter((item) => item.group_id !== "").map(group => ({
                    value: +group.group_id,
                    label: group.Groups
                }));
            }

            setState((prevState) => ({
                ...prevState,
                groupsArray: groupData,
                villagesArray: villageData,
                selected_villages: villageData,
                selected_groups: groupData
            }));
        }
    }, [villageGroups, user.level_id, years,user_client_id]);

    const handleInputChange = (name, value) => {
        if (name === "years") {
            setYearId(value);
            handleVillageGroupAdoptionSummary(value);
        }
    };

    const addSpacesToPracticeName = (practiceName) => {
        const spacedName = practiceName.replace(/([a-z])([A-Z])/g, '$1 $2');
        return spacedName.charAt(0).toUpperCase() + spacedName.slice(1);
    };

    const handleLevelsChange = (level) => {
        setState((prevState) => ({
            ...prevState,
            selectedRadioOption: level
        }));
        if (level === 1) {
            setState((prevState) => ({
                ...prevState,
                selected_villages: state.villagesArray
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                selected_villages: []
            }));
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleExcelDownload = (villageGroupAdoptionSummaryReport, state, farmers) => {
        // Generate the headers dynamically
        const headers = [
            state.selectedRadioOption === 1 ? 'SNO' : 'SNO',
            state.selectedRadioOption === 1 ? 'Village Name' : 'Group Name',
            'Total Farmers',
            'No of Growing Farmers',
            ...(
                villageGroupAdoptionSummaryReport[0]?.adoption_report[0]
                    ? Object.keys(villageGroupAdoptionSummaryReport[0].adoption_report[0]).flatMap(practice => [
                        `${practice} - Yes`,
                        `${practice} - No`
                    ])
                    : []
            )
        ];

        const rows = villageGroupAdoptionSummaryReport
            .filter(village => {
                const hasValidGroup = state.selectedRadioOption === 1
                    ? village.village_id !== null && state.selected_villages.find(e => parseInt(e.value) === parseInt(village.village_id))
                    : village.group_id !== null && state.selected_groups.find(e => parseInt(e.value) === parseInt(village.group_id));
                return hasValidGroup;
            })
            .map((village, index) => {
                const displayName = state.selectedRadioOption === 1 ? village.village_name : village.group_name;
                const farmersCount = state.selectedRadioOption === 1
                    ? farmers.filter(item => item.village_id === village.village_id).length
                    : farmers.filter(item => item.ff_group_id === village.group_id).length;

                const adoptionData = village.adoption_report && village.adoption_report[0]
                    ? Object.entries(village.adoption_report[0]).flatMap(([practice, results]) => [results.yes, results.no])
                    : [];

                return [index + 1, displayName, farmersCount, village.totalFarmersAttendedCount, ...adoptionData];
            });

        const excelData = [headers, ...rows];

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, 'DynamicReport.xlsx');
    };


    const handleMultiSelectChange = (name, selectedValues) => {
        setState((prev) => ({
            ...prev,
            [name]: selectedValues,
        }));
    };



    const tableRows = useMemo(() => {
        return villageGroupAdoptionSummaryReport
            .filter((village) => {
                const hasValidGroup = state.selectedRadioOption === 1
                    ? village.village_id !== null && state.selected_villages.find(e => parseInt(e.value) === parseInt(village.village_id))
                    : village.group_id !== null && state.selected_groups.find(e => parseInt(e.value) === parseInt(village.group_id));

                return hasValidGroup;
            })

            .map((village, index) => {

                const displayName = state.selectedRadioOption === 1 ? village.village_name : village.group_name;
                const farmersCount = state.selectedRadioOption === 1 ? farmers.filter((item) => item.village_id === village.village_id).length : farmers.filter((item) => item.ff_group_id === village.group_id).length
                return (
                    <TableRow key={village.village_id || village.group_id}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">{displayName}</TableCell>
                        <TableCell align="center">{farmersCount}</TableCell>
                        <TableCell align="center">
                            {village.totalFarmersAttendedCount}
                        </TableCell>

                        {village.adoption_report?.[0] &&
                            Object.entries(village.adoption_report[0]).map(
                                ([, results], i) => (
                                    <React.Fragment key={i}>
                                        <TableCell align="center">
                                            {results?.yes ?? 0}
                                        </TableCell>
                                        <TableCell align="center">
                                            {results?.no ?? 0}
                                        </TableCell>
                                    </React.Fragment>
                                )
                            )}
                    </TableRow>
                );
            });
    }, [villageGroupAdoptionSummaryReport, state.selected_villages, state.selected_groups, state.selectedRadioOption, searchTerm]);
    
    return (
        <>
            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />
            <Box mt={1}>
                <Card elevation={6}>

                    <Grid container spacing={1} p={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        {
                            [{ id: 1, label: "Select Year", name: "yearId", value: yearId, options: years, disabled: true }
                            ].map((field, index) => (
                                <Grid item key={index} size={{ xs: 12, md: 4 }}>
                                    <SingleSelect
                                        name={field.name}
                                        label={field.label}
                                        options={field.options || []}
                                        value={field.value}
                                        disabled={field.disabled}
                                        onChange={handleInputChange}
                                        error={field.error}
                                        formHelperText={true}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>

                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid container>
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    {levels.length > 0 ? (
                                        <RadioGroup
                                            row
                                            name="radioOption"
                                            value={state.selectedRadioOption}
                                            onChange={(e) => handleLevelsChange(Number(e.target.value))}
                                        >
                                            {levels.map((item) => (
                                                <FormControlLabel
                                                    key={item.value}
                                                    value={item.value}
                                                    control={<Radio color="success" />}
                                                    label={
                                                        <Typography fontSize={14}>
                                                            {item.label}
                                                        </Typography>
                                                    }
                                                    sx={{ mr: 3 }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">
                                            Levels are not found
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            {
                                (+state.selectedRadioOption === 1 ?
                                    [{ id: 1, name: "selected_villages", value: state.selected_villages, options: state.villagesArray, label: "Select Villages" }] :
                                    [{ id: 2, name: "selected_groups", value: state.selected_groups, options: state.groupsArray, label: "Select Groups" }]).map((field, index) => (
                                        <Grid item size={{ xs: 12, md: 4 }}>
                                            <MultiSelectWithAll
                                                name={field.name}
                                                label={field.label}
                                                options={field.options}
                                                value={state[field.name] || []}
                                                onChange={handleMultiSelectChange}
                                            />
                                        </Grid>
                                    ))
                            }

                            <Grid item size={{ xs: 12, md: 4 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <CustomButton status={false} onClick={() => handleExcelDownload(villageGroupAdoptionSummaryReport, state, farmers)} label="Download Excel" icon={<DownloadIcon />} loadingLabel="Submitting.." />
                            </Grid>
                        </Grid>


                        {villageGroupAdoptionSummaryReport.length > 0 ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                width="100%"
                            >
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        boxShadow: 6,
                                        mt: 2,
                                        maxHeight: "60vh",
                                        width: "100%",
                                        maxWidth: "95%",
                                        overflowY: "auto",
                                        overflowX: { xs: "auto", md: "hidden" },
                                        WebkitOverflowScrolling: "touch",
                                    }}
                                >
                                    <Table
                                        size="small"
                                        sx={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <TableHead
                                            sx={{
                                                color: clientTheme.activeTextColor,
                                                backgroundColor: clientTheme.activeBg,
                                            }}
                                        >
                                            {/* FIRST HEADER ROW */}
                                            <TableRow>
                                                <TableCell rowSpan={2} sx={{ color: clientTheme.activeTextColor, p: 1.5, textAlign: "center" }}><b>SNO</b></TableCell>

                                                <TableCell rowSpan={2} sx={{ color: clientTheme.activeTextColor, p: 1.5, textAlign: "center" }}>
                                                    <b>
                                                        {state.selectedRadioOption === 1
                                                            ? "Village Name"
                                                            : "Group Name"}
                                                    </b>
                                                </TableCell>

                                                <TableCell rowSpan={2} sx={{ color: clientTheme.activeTextColor, p: 1.5, textAlign: "center" }}><b>Total Farmers</b></TableCell>
                                                <TableCell rowSpan={2} sx={{ color: clientTheme.activeTextColor, p: 1.5, textAlign: "center" }}><b>No of Growing Farmers</b></TableCell>

                                                {villageGroupAdoptionSummaryReport[0]?.adoption_report[0] &&
                                                    Object.keys(
                                                        villageGroupAdoptionSummaryReport[0].adoption_report[0]
                                                    ).map((practice, index) => (
                                                        <TableCell
                                                            key={index}
                                                            colSpan={2}
                                                            align="center"
                                                            p={2}
                                                        >
                                                            <b>{addSpacesToPracticeName(practice)}</b>
                                                        </TableCell>
                                                    ))}
                                            </TableRow>

                                            {/* SECOND HEADER ROW */}
                                            <TableRow>
                                                {villageGroupAdoptionSummaryReport[0]?.adoption_report[0] &&
                                                    Object.keys(
                                                        villageGroupAdoptionSummaryReport[0].adoption_report[0]
                                                    ).map((_, index) => (
                                                        <React.Fragment key={index}>
                                                            <TableCell align="center"><b>Yes</b></TableCell>
                                                            <TableCell align="center"><b>No</b></TableCell>
                                                        </React.Fragment>
                                                    ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tableRows}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        ) : (
                            <Box textAlign="center" py={3}>
                                <Typography variant="subtitle1" color="text.secondary">
                                    No data available
                                </Typography>
                            </Box>
                        )}

                    </CardContent>

                </Card>
            </Box>
        </>
    );
}

export default AdOptionOveralReport;
